import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const ADD_INVOICE = gql`
  mutation AddConsultantInvoice($newInvoice: NewConsultantInvoiceRequestDto!) {
    addConsultantInvoice(newInvoice: $newInvoice) {
      uuid
      manualCommission
      commission
      invoiceDate
      periodStart
      periodEnd
      paymentDate
      clientName
      invoiceNumber
      currency
      dailyRateConsultant
      dailyRateClient
      daysWorked
      month
      year
      amountConsultant
      amountClient
      boondManagerInvoiceId
    }
  }
`;

export const useAddInvoice = () => {
    const [addInvoice, { loading, error, data }] = useMutation(ADD_INVOICE);

    return { addInvoice, loading, error, data };
};
